export default class CustomerOccupationModel {
  constructor(obj) {
    obj = obj || {};
    this.id = obj.id;
    this.company = obj.company;
    this.companySector = obj.companySector || null;
    this.profession = obj.profession;
    this.position = obj.position;
    this.professionId = obj.professionId;
    this.professionDescription = obj.professionDescription;
    this.createdAt = obj.createdAt;
    this.updatedAt = obj.updatedAt;
  }
}
